const SittinOnTheDockOfTheBay = [
	'[Verse 1]',
	"Sittin' in the morning sun",
	"I'll be sittin' when the evening come",
	'Watching the ships roll in',
	"then I'll watch 'em roll away again, yeah",
	'',
	'[Chorus]',
	"I'm just sittin' on the dock of the bay",
	'watching the tide roll away',
	"ooo I'm sittin' on the dock of the bay",
	'wasting ti---ime',
	'',
	'[Verse 2]',
	'I left my home in Georgia and I',
	'Headed for the Frisco bay',
	"'Cause I've got nothing to live for",
	"Look like nothing's gonna come my way",
	'',
	'[Chorus]',
	"I'm just sittin' on the dock of the bay",
	'watching the tide roll away',
	"ooo I'm sittin' on the dock of a bay",
	'wasting ti---ime',
	'',
	'[Bridge]',
	"Look like nothing's gonna change",
	'Everything seems to stay the same',
	"I can't do what ten people tell me to do",
	"So I guess I'll remain the same",
	'',
	'[Verse 3]',
	"Sittin' here resting my bones",
	"and this loneliness won't leave me a--lone",
	'These 2000 miles I roamed',
	'just to make this dock my home',
	'',
	'[Chorus]',
	"I'm sittin' on the dock of the bay",
	'Watching the tide roll away. ooo',
	"Sittin' on the dock of the bay",
	"I'm wasting ti---ime",
];

export default SittinOnTheDockOfTheBay;
